import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "bootstrap/dist/css/bootstrap.min.css";
import "swiper/css/swiper.css";
import * as serviceWorker from "./serviceWorker";
import { LoadingProvider } from "./context/LoadingContext";

ReactDOM.render(
  // <LoadingProvider>
  <App />,
  // </LoadingProvider>,
  document.getElementById("root")
);

serviceWorker.unregister();
